import React from 'react';
import Radium from 'radium';
import Card from './components/Card';
import LandingPageLink from './components/links/LandingPageLink';
import Notice from './components/Notice';
import RawHtml from './components/RawHtml';
import StyleDecorator from './components/StyleDecorator';
import SipgateFormHeaderLogo from './components/images/SipgateFormHeaderLogo';
import translate from './locale/translate';
import Theme from './styles/theme';
import Button from './components/buttons/Button';

const UnknownUserApp = () => {
	const style = {
		marginTop: '35px',
		backgroundColor: Theme.palette.primary1Color,
		':hover': {
			cursor: 'pointer',
		},
	};

	return (
		<Card
			header={<SipgateFormHeaderLogo />}
			footer={<LandingPageLink />}
		>
			<Notice>
				<h3>{translate('UNKNOWN_USER_TITLE')}</h3>
				<RawHtml
					inner={translate('UNKNOWN_USER_BODY')}
					tag={'p'}
				/>
				<Button
					style={style}
					onTouchTap={() => { window.location.href = '/'; }}
				>
					{translate('LABEL_NAVIGATE_TO_LOGIN')}
				</Button>
			</Notice>
		</Card>
	);
};

UnknownUserApp.propTypes = {
	visible: React.PropTypes.bool,
	mediaQueries: React.PropTypes.object,
};

export default StyleDecorator(Radium(UnknownUserApp));



// WEBPACK FOOTER //
// ./src/UnknownUserApp.js